import { ReactComponent as SvgPin } from '@img/icons/pin.svg';
import { ReactComponent as SvgX } from '@img/icons/x.svg';
import noop from 'lodash/noop';
import React from 'react';
import CheckboxSelect from '../FormFields/CheckboxSelectField/CheckboxSelectField';
import PostcodeModal from '../Modals/PostcodeModal/PostcodeModal';
import S from './APLFilters.styles';
import SearchField from './SearchField/SearchField';
const APLFilters = ({ alignment = 'center', filterTheme = 'lightGrey', sortByOptions, sortByValue, title, professionFilters, professionValues, countyFilters, countyValues, servicesFilters, servicesValues, onFilterChange, onSearchTermChange, searchTerm, onSortChange = noop, onPostcodeSearch = noop, onPostcodeSubmit = noop, showPostcodeModal = false, onPostcodeModalClose = noop, postcodeValue, onClearPostcode = noop, onClearSelected = noop, onClearAllFilters = noop, }) => {
    const selectedValues = [professionValues, countyValues, servicesValues].flat();
    function updateProfessionFilters(key, value, e) {
        e.stopPropagation();
        if (professionValues && onFilterChange) {
            const tempValues = professionValues;
            if (!tempValues.includes(value)) {
                tempValues.push(value);
                onFilterChange(key, tempValues);
            }
            else {
                const newList = tempValues.filter((prof) => prof !== value);
                onFilterChange(key, newList);
            }
        }
    }
    function updateCountyFilters(key, value, e) {
        e.stopPropagation();
        if (countyValues && onFilterChange) {
            const tempValues = countyValues;
            if (!tempValues.includes(value)) {
                tempValues.push(value);
                onFilterChange(key, tempValues);
            }
            else {
                const newList = tempValues.filter((prof) => prof !== value);
                onFilterChange(key, newList);
            }
        }
    }
    function updateServicesFilters(key, value, e) {
        e.stopPropagation();
        if (servicesValues && onFilterChange) {
            const tempValues = servicesValues;
            if (!tempValues.includes(value)) {
                tempValues.push(value);
                onFilterChange(key, tempValues);
            }
            else {
                const newList = tempValues.filter((prof) => prof !== value);
                onFilterChange(key, newList);
            }
        }
    }
    function updateSortByFilter(key, value, e) {
        e.stopPropagation();
        onSortChange(value);
    }
    return (React.createElement(S.Container, { theme: filterTheme },
        title && React.createElement(S.Title, null, title),
        React.createElement(S.FiltersRow, { alignment: alignment },
            React.createElement(S.Filter, null,
                React.createElement(SearchField, { onSearchTermChange: onSearchTermChange, searchResultsPlaceholder: 'Search by member name…', initialValue: searchTerm }),
                searchTerm !== '' ? (React.createElement(S.ClearFilter, null,
                    React.createElement("button", { onClick: () => onSearchTermChange('') }, "clear search"))) : null),
            React.createElement(S.Filter, null,
                React.createElement(CheckboxSelect, { filters: professionFilters, values: professionValues, updateFilters: updateProfessionFilters, allowMulti: true }),
                professionValues?.length ? (React.createElement(S.ClearFilter, null,
                    React.createElement("button", { onClick: () => onFilterChange(professionFilters.key, []) }, "clear filter"))) : null),
            React.createElement(S.Filter, null,
                React.createElement(CheckboxSelect, { filters: countyFilters, values: countyValues, updateFilters: updateCountyFilters, allowMulti: true }),
                countyValues?.length ? (React.createElement(S.ClearFilter, null,
                    React.createElement("button", { onClick: () => onFilterChange(countyFilters.key, []) }, "clear filter"))) : null),
            React.createElement(S.Filter, null,
                React.createElement(CheckboxSelect, { filters: servicesFilters, values: servicesValues, updateFilters: updateServicesFilters, allowMulti: true }),
                servicesValues?.length ? (React.createElement(S.ClearFilter, null,
                    React.createElement("button", { onClick: () => onFilterChange(servicesFilters.key, []) }, "clear filter"))) : null),
            React.createElement(S.Filter, null,
                React.createElement(S.PostcodeSearchButton, { onClick: onPostcodeSearch },
                    React.createElement(SvgPin, null),
                    " ",
                    React.createElement("strong", null, "Postcode:"),
                    " ",
                    postcodeValue ? postcodeValue : 'Search'),
                postcodeValue && (React.createElement(S.ClearFilter, null,
                    React.createElement("button", { onClick: () => onClearPostcode(false), title: "Edit" }, postcodeValue),
                    React.createElement("button", { onClick: () => onClearPostcode(true), title: "Clear Filter" }, "\u00D7")))),
            sortByOptions && (React.createElement(S.Filter, null,
                React.createElement(CheckboxSelect, { filters: { key: 'sortBy', options: sortByOptions, title: 'Sort by' }, values: [sortByValue], updateFilters: updateSortByFilter })))),
        React.createElement(PostcodeModal, { visible: showPostcodeModal, onClose: onPostcodeModalClose, onSubmit: onPostcodeSubmit }),
        selectedValues.length > 0 ? (React.createElement(S.SelectedFiltersContainer, null,
            React.createElement(S.Title, null, "Selected Filters"),
            React.createElement(S.SelectedFilters, null,
                selectedValues.map((value) => (React.createElement(S.SelectedFilterValue, { key: `selected-filter-option-${value}`, themeOption: "aplGreenLight", title: value, icon: SvgX, onClick: () => onClearSelected(value) }))),
                selectedValues.length > 1 && (React.createElement(S.ClearAllSelected, { themeOption: "blackOutline", title: "Clear All", icon: SvgX, onClick: onClearAllFilters }))))) : null));
};
export default APLFilters;
